export default function MarkerPin({ ...props }) {
    return (
        <svg
            width="20"
            height="19"
            viewBox="0 0 20 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M13.3327 10.1454C16.2759 10.724 18.3327 12.0456 18.3327 13.5833C18.3327 15.6544 14.6017 17.3333 9.99935 17.3333C5.39698 17.3333 1.66602 15.6544 1.66602 13.5833C1.66602 12.0456 3.72284 10.724 6.66602 10.1454M9.99935 13.1667V6.5M9.99935 6.5C11.3801 6.5 12.4993 5.38071 12.4993 4C12.4993 2.61929 11.3801 1.5 9.99935 1.5C8.61864 1.5 7.49935 2.61929 7.49935 4C7.49935 5.38071 8.61864 6.5 9.99935 6.5Z"
                stroke="currentColor"
                strokeWidth="1.66667"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
